import React, { useRef, useState, useEffect } from "react";
import { View, Modal, StyleSheet, Animated, Image } from "react-native";
import Text from "@components/AppText";
import colors from "@constants/color";
import CityMallLongLogo from "@assets/svg/CityMallLongLogo";

import t from "../constants/localization";

const PATH = "components/CodePushModal";

const CodePushModal = (props) => {
  const { progress, progressModal } = props || {};
  const animation = useRef(new Animated.Value(0));

  useEffect(() => {
    Animated.timing(animation.current, {
      toValue: progress,
      duration: 100,
      useNativeDriver: false,
    }).start();
  }, [progress]);

  const width = animation.current.interpolate({
    inputRange: [0, 100],
    outputRange: ["0%", "100%"],
    extrapolate: "clamp",
  });

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      animationType="slide"
      transparent
      visible={progressModal}
    >
      <View style={styles.container}>
        <CityMallLongLogo height={32} width={110} />

        <View
          style={{
            flex: 1,
            justifyContent: "center",
          }}
        >
          <View
            style={{
              alignItems: "center",
              marginBottom: 80,
            }}
          >
            <Image
              source={require("../assets/codepush.gif")}
              style={{
                width: 180,
                height: 180,
              }}
            />
          </View>

          <Text
            fontType="head3"
            style={{
              color: colors.black,
              textAlign: "center",
              fontWeight: "bold",
              marginVertical: 12,
              fontSize: 20,
              marginBottom: 30,
            }}
          >
            {t(`${PATH}/updatingApp`)}
          </Text>

          <Text
            style={{
              color: "rgba(0,0,0,0.56)",
              fontWeight: "bold",
              fontSize: 12,
              marginLeft: 12,
              marginBottom: 2,
            }}
          >
            {`${progress}%`}
          </Text>
          <View style={styles.progressBar}>
            <Animated.View
              style={
                ([StyleSheet.absoluteFill],
                { backgroundColor: "#27AE60", width, borderRadius: 10 })
              }
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
    flex: 1,
    paddingHorizontal: 15,
    paddingVertical: 30,
  },
  progressBar: {
    flexDirection: "row",
    height: 6,
    width: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    borderRadius: 10,
  },
  beLikeRow: {
    flexDirection: "row",
  },
  wrapper: {
    backgroundColor: "#fff",
    elevation: 5,
    width: "100%",
    padding: 20,
  },
  couponTxtContainer: {
    justifyContent: "center",
    paddingVertical: 8,
  },
  graphicContainer: {
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    overflow: "hidden",
    paddingVertical: 8,
  },
});

export default CodePushModal;
